import { useEffect, useState } from 'react'
import { api } from './api'

/**
 * The server's IP-detected country (ISO alpha-2), fetched once from
 * `GET /auth/geo`. This follows the real client IP — so a VPN changes it —
 * unlike the phone field's own guess, which reads the browser's OS timezone
 * (a VPN does NOT change that). Signup / Complete-Profile pass this as the
 * phone `defaultCountry` so the dial code matches the user's actual location,
 * while the user can still change it manually.
 *
 * Returns `null` while loading or when the IP can't be resolved
 * (localhost / private / unknown range); callers then fall back to the phone
 * component's browser-timezone default. Best-effort: any error resolves to
 * `null` and never blocks the form.
 */
export function useDetectedCountry() {
  const [country, setCountry] = useState(null)
  useEffect(() => {
    let alive = true
    api
      .get('/auth/geo')
      .then((res) => {
        if (alive) setCountry(res.data?.country ?? null)
      })
      .catch(() => {
        if (alive) setCountry(null)
      })
    return () => {
      alive = false
    }
  }, [])
  return country
}
